import { Colors, Styles } from "../preset.constants";

export const selectPreset = {
    background: Colors.PrimaryBackground,
    color: Colors.DefaultTextColor,
    border: {
        color: Colors.SuccessColor,
        radius: Styles.BorderRadiusSM
    },
    overlay: {
        background: Colors.PrimaryBackground,
        color: Colors.DefaultTextColor,
        border: {
            color: Colors.BorderColor
        }
    },
    option: {
        color: Colors.DefaultTextColor
    }
}